/**
 * @generated SignedSource<<f34ef68b6720113ae6080be7e147846f>>
 * @relayHash d391106a23a67856a854693f3b3e882c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c0a31f72a0130e8d300a6bd34b24ae0677779662bb4f97d34c29d043ac2b4e9a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c0a31f72a0130e8d300a6bd34b24ae0677779662bb4f97d34c29d043ac2b4e9a",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
